/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TemplatePrescription from './template-prescription';
import TemplatePrescriptionDetail from './template-prescription-detail';
import TemplatePrescriptionUpdate from './template-prescription-update';
import TemplatePrescriptionDeleteDialog from './template-prescription-delete-dialog';

const TemplatePrescriptionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TemplatePrescription />} />
    <Route path="new" element={<TemplatePrescriptionUpdate />} />
    <Route path=":id">
      <Route index element={<TemplatePrescriptionDetail />} />
      <Route path="edit" element={<TemplatePrescriptionUpdate />} />
      <Route path="delete" element={<TemplatePrescriptionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TemplatePrescriptionRoutes;
